import { render, staticRenderFns } from "./HandleProductSidebar.vue?vue&type=template&id=0cf1f124&scoped=true&"
import script from "./HandleProductSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleProductSidebar.vue?vue&type=style&index=0&id=0cf1f124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1f124",
  null
  
)

export default component.exports